<template>
  <div class="cpf-input" :class="{'error': hasErrors, 'success': status === 'valid'}">
    <input
      ref="input"
      :id="id"
      :name="name"
      v-bind="$attrs"
      v-mask="config"
      v-model="currentValue"
      :placeholder="placeholder || '415.656.333-67'"
      :type="type"
      @input="refresh($event.target.value)"
    />
    <span v-if="hasErrors" class="cpf-input__error-message">{{ errorMessage }}</span>
  </div>
</template>

<script>
import mask from '@/assets/masker/masker.directive'
import masker from '@/assets/masker/masker'
import tokens from '@/assets/masker/tokens'

export default {
  name: 'CpfInput',
  directives: { mask },
  props: {
    value: {},  // eslint-disable-line
    label: {
      type: String,
      default: () => null
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'input'
    },
    type: {
      type: String,
      default: 'text'
    },
    errorMessage: {
      type: String,
      default: 'text'
    },
    errorCondition: {
      type: Boolean,
      default: false
    },
    mask: {
      type: [ String, Array ],
      required: false,
      default () {
        return 'N'.repeat(240)
      }
    },
    masked: {
      type: Boolean,
      default: false
    },
    tokens: {
      type: Object,
      default: () => tokens
    }
  },
  data () {
    return {
      currentValue: null,
      lastValue: null,
      status: '',
      timeout: null,
      hasErrors: false
    }
  },
  computed: {
    config () {
      return {
        mask: this.mask,
        masked: this.masked,
        tokens: this.tokens
      }
    }
  },
  watch: {
    value (newValue) {
      if (newValue !== this.lastValue) {
        this.refresh(newValue)
      }
    },
    masked () {
      this.refresh(this.currentValue)
    }
  },
  methods: {
    refresh (value) {
      this.currentValue = value
      const refreshValue = masker(value, this.mask, this.masked, this.tokens)
      if (refreshValue !== this.lastValue) {
        this.validator()
        this.lastValue = refreshValue
        this.$emit('input', refreshValue)
      }
    },
    async validator () {
      this.hasErrors = false
      this.status = 'typing'
      clearTimeout(this.timeout)
      this.timeout = this.invalidTimeout()
    },
    invalidTimeout () {
      return setTimeout(() => {
      this.hasErrors = this.errorCondition
      this.status = this.errorCondition ? 'invalid' : 'valid'
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.cpf-input {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    max-width: 368px;
  }

  input {
    background: #FFFFFF;
    border: solid 1px #C2C2C7;
    border-radius: 8px;
    color: #716E82;
    font-family: Rubik;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    height: 48px;
    outline: none;
    padding: 12px 16px;
  }

  &.error {
    &:after {
      background-color: red;
      content: '';
      height: 21px;
      mask-image: url('~@/assets/svg/icons-status-cancel.svg');
      mask-position: center;
      mask-repeat: no-repeat;
      mask-size: cover;
      position: absolute;
      right: 18px;
      top: calc(50% - (21px / 2));
      width: 21px;
    }

    input {
      border-color: #DF2E24;
    }
  }

  &.success {
    &:after {
      background-color: green;
      content: '';
      height: 21px;
      mask-image: url('~@/assets/svg/icons-status-success.svg');
      mask-position: center;
      mask-repeat: no-repeat;
      mask-size: cover;
      position: absolute;
      right: 18px;
      top: calc(50% - (21px / 2));
      width: 21px;
    }

    input {
      border-color: green;
    }
  }

  span {
    bottom: -20px;
    color: #DF2E24;
    font-size: 12px;
    left: 0;
    position: absolute;
  }
}
</style>
